// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-column[data-v-7159ee92] {\n  position: sticky;\n  top: 10px;\n  max-height: 95vh;\n  overflow-y: scroll;\n}\n.disabled-option[data-v-7159ee92] {\n  cursor: not-allowed;\n  color: #808080;\n}", ""]);
// Exports
module.exports = exports;
